export default __webpack_public_path__ + "static/Cryopod-513f54dcb175f12836e1d00d0f951d28.png";